import { useDispatch, useSelector } from "react-redux";
import {
  generateSelectContent,
  renderUserName,
} from "../../../utils/constants";
import React, { useEffect, useRef, useState } from "react";
import { Button, Space } from "antd";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import { clearBills, getBilling, setPagination } from "../Slices/Billing.slice";
import CustomForm from "../../../shared/components/CustomForm";
import { RiMenuSearchLine } from "react-icons/ri";
import CustomTable from "../../../shared/components/CustomTable";
import routes from "../../../engine/routes";
import { BillsByTypeInputs } from "./BillsByTypeInputs";
import { billsByTypeColumns } from "./BillsByTypeColumns";
import { BillsExportFile } from "./BillsExportFile";
import { createPortal } from "react-dom";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import LogHistory from "../../../shared/components/LogHistory";

export const BillsByType = ({ name, isExternal, setYear, type }) => {
  const { bills, loading, pagination, countType } = useSelector(
    state => state.billing,
  );

  const dispatch = useDispatch();

  const { monthsSelectContent, yearsSelectContent } = generateSelectContent();

  const initSearch = {
    groupedBilling: type,
    year: yearsSelectContent[0].value,
  };

  const initialValuesForm = {
    year: yearsSelectContent[0].value,
  };

  const [search, setSearch] = useState(initSearch);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const dispatchActionGetBills = async (forceSearch = search) => {
    setSelectedRowKeys([]);
    setYear(forceSearch.year);

    const searchChanged = objectToUrlParams({
      isExternal,
      ...forceSearch,
      ...pagination,
    });

    dispatch(getBilling({ search: searchChanged, key: name }));
  };

  const onSelectChange = r => {
    setSelectedRowKeys(r);
  };

  useEffect(() => {
    // dispatchActionGetBills();
    return () => {
      dispatch(clearBills());
    };
  }, []);

  useEffect(() => {
    dispatchActionGetBills();
  }, [pagination.currentPage, pagination.pageSize, pagination.sorter]);

  const columns = billsByTypeColumns({ type });

  const formRef = useRef();

  const handleKeyUp = async event => {
    // Enter
    if (event.keyCode === 13) {
      await dispatchActionGetBills();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  const onValuesChange = (changedValues, allValues) => {
    setSearch({ ...search, ...changedValues });
  };

  const inputs = BillsByTypeInputs({
    type,
    monthsSelectContent,
    yearsSelectContent,
    dispatchActionGetBills,
    setSearch,
    formRef,
    loading,
    initSearch,
    initialValuesForm,
  });

  const actionsBills = (
    <Space
      style={{
        width: "100%",
        marginTop: "10px",
        flexDirection: "row",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <BillsExportFile selectedRowKeys={selectedRowKeys} type={type} />
    </Space>
  );

  const node = document.getElementById("actionsBills");
  const nodeForm = document.getElementById("formBills");

  return (
    <div>
      {node !== null && createPortal(actionsBills, node, type)}

      {nodeForm !== null &&
        createPortal(
          <CustomForm
            saveLocalStorage={true}
            idLocalStorage={`interpretes_list_${type}_${isExternal}`}
            initialValues={initialValuesForm}
            refForm={formRef}
            onKeyUp={handleKeyUp}
            style={{
              flex: 1,
              maxWidth: "100%",
            }}
            dataSource={inputs}
            labelCol={24}
            wrapperCol={24}
            onValuesChange={onValuesChange}
            handleSubmit={async data => {
              await dispatchActionGetBills(data);
            }}
          />,
          nodeForm,
          type,
        )}
      <CustomTable
        scroll={{ y: 1000, x: 1000 }}
        loading={loading}
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{renderUserName(item)}</h2>
            </div>
          );
        }}
        onRowLink={record => routes.billing(record._id).detail.path}
        pagination={{
          hideOnSinglePage: false,
          position: ["topRight"],
          defaultPageSize: pagination.pageSize,
          pageSizeOptions: [10, 20, 50, 100, 250, 500, 1000],
          showSizeChanger: true,
          current: pagination.currentPage,
          total: pagination.totalDocuments,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} sur ${total} factures`,
        }}
        hasSelection={true}
        rowSelectedKeys={selectedRowKeys}
        onSelectChange={onSelectChange}
        onChange={async (p, filters, sorter, extra) => {
          let extraSorter = {};

          if (sorter.order !== undefined) {
            extraSorter = {
              sorter: {
                key: sorter.columnKey,
                order: sorter.order,
              },
            };
          } else {
            extraSorter = {
              sorter: undefined,
            };
          }

          await dispatch(
            setPagination({
              currentPage: p.current,
              pageSize: p.pageSize,
              ...extraSorter,
            }),
          );
        }}
        dataSource={bills}
        columns={columns}
        rowKey="_id"
      />
    </div>
  );
};
